import { createBrowserRouter, Navigate } from 'react-router'

import { AdminRoute } from '@/auth/admin-route'
import { ParentRoute } from '@/auth/parent-route'
import { ProtectedRoute } from '@/auth/protected-route'
import { AdminAgentReleases } from '@/routes/admin/agent-releases'
import { AdminDeviceDetail } from '@/routes/admin/device-detail'
import { AdminFamilies } from '@/routes/admin/families'
import { AdminFamilyDetail } from '@/routes/admin/family-detail'
import { AdminSettings } from '@/routes/admin/settings'
import { AppLayout } from '@/routes/app-layout'
import { Blocked } from '@/routes/blocked'
import { DeviceList } from '@/routes/device-list'
import { DeviceScreen } from '@/routes/device-screen'
import { Login } from '@/routes/login'
import { ParentLayout } from '@/routes/parent-layout'

export const router = createBrowserRouter([
  { path: '/login', element: <Login /> },
  { path: '/blocked', element: <Blocked /> },
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <ParentRoute />,
        children: [
          {
            element: <ParentLayout />,
            children: [
              { index: true, element: <DeviceList /> },
              { path: 'devices/:deviceId', element: <DeviceScreen /> },
            ],
          },
        ],
      },
      {
        element: <AppLayout />,
        children: [
          {
            path: 'admin',
            element: <AdminRoute />,
            children: [
              { index: true, element: <Navigate to="families" replace /> },
              { path: 'families', element: <AdminFamilies /> },
              { path: 'families/:familyId', element: <AdminFamilyDetail /> },
              {
                path: 'families/:familyId/devices/:deviceId',
                element: <AdminDeviceDetail />,
              },
              { path: 'agent-releases', element: <AdminAgentReleases /> },
              { path: 'settings', element: <AdminSettings /> },
            ],
          },
        ],
      },
    ],
  },
  { path: '*', element: <Navigate to="/" replace /> },
])
